import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import ColorPickerComponent from 'routes/Admin/components/CommonComponents/ColorPickerComponent'
const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    width: 200
  }
})
class EditBarModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    updateBarInfo: PropTypes.func.isRequired
  }
  state = {
    bar: null
  }
  handleValidate = () => {
    const { bar } = this.state
    this.props.updateBarInfo(this.props.transaction, bar)
  }
  handleNameChange = e => {
    this.setState({ bar: { ...this.state.bar, name: e.target.value } })
  }
  handleColorSelection = color => {
    this.setState({ bar: { ...this.state.bar, color: color } })
  }
  componentWillMount() {
    if (this.props.transaction.bar) {
      this.setState({ bar: this.props.transaction.bar })
    }
  }
  render() {
    const { classes } = this.props
    const { bar } = this.state
    return (
      <ModalWrapper
        appBar
        open
        onOk={this.handleValidate}
        title={`Changer le tarif en cours`}
        okDisabled={bar.name === ''}
        showOk>
        <Grid container direction="row" justify="center">
          <TextField
            id="bar-name"
            label="Nom"
            type="text"
            onChange={this.handleNameChange}
            value={bar.name}
            className={classes.textField}
            InputLabelProps={{
              shrink: true
            }}
          />
          <ColorPickerComponent
            colorValidate={this.handleColorSelection}
            color={bar.color}
          />
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(EditBarModal)



// WEBPACK FOOTER //
// ./src/components/modals/client/EditBarModal.js